import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CylinderVerticalIcon = function CylinderVerticalIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CylinderVerticalIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsxs("g", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: ".9",
      strokeWidth: "1.45",
      clipPath: "url(#clip0_1217_61344)",
      children: [jsx("path", {
        d: "M3.333 4c0 .263.121.523.355.765.235.243.579.464 1.012.65.433.185.948.332 1.514.433S7.387 6 8 6s1.22-.052 1.786-.152 1.08-.248 1.514-.434c.433-.185.777-.406 1.011-.649.235-.242.356-.502.356-.765s-.121-.523-.356-.765c-.234-.243-.578-.463-1.011-.65a7 7 0 0 0-1.514-.433C9.22 2.052 8.613 2 8 2s-1.22.052-1.786.152-1.08.248-1.514.434-.777.406-1.012.649c-.234.242-.355.502-.355.765"
      }), jsx("path", {
        d: "M3.333 4v8c0 1.105 2.09 2 4.667 2s4.667-.895 4.667-2V4"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_1217_61344",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

export { CylinderVerticalIcon };
